import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitEnquiry(payload) {
  // payload: { kind, email, name?, message?, property? }
  const res = await axios.post(`${API_BASE}/enquiries`, payload, {
    headers: { "Content-Type": "application/json" }
  });
  return res.data;
}
